import React from "react";

import { Swiper, SwiperSlide } from "swiper/react";
import { faStar, faUser } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// import required modules
import { Pagination, Navigation, Autoplay } from "swiper/modules";
import { defaultImg } from "../Constants/Images";
import {
  formatSpaceRate,
  hasSpaceRate,
  SPACE_RATE_UNAVAILABLE_HELP,
  SPACE_RATE_UNAVAILABLE_LABEL,
} from "../utils/helpers";

const SpaceGridItem = ({ item, listview = false, onClick }) => {
  const sliderImgs = item.media ? item.media : [];

  const listTypeClass = listview
    ? "space-item space-list-item as-link"
    : "space-item space-grid-item as-link";

  return (
    <div className={listTypeClass} onClick={onClick}>
      {sliderImgs.length == 0 && (
        <div className="space-img-slider">
          <img src={defaultImg} alt="" />
        </div>
      )}

      {sliderImgs.length > 0 && (
        <div className="space-img-slider">
          <Swiper
            navigation={true}
            pagination={true}
            modules={[Autoplay, Navigation, Pagination]}
            autoplay={{
              delay: 2500,
              disableOnInteraction: false,
            }}
          >
            {sliderImgs.map((imgItem, index) => (
              <SwiperSlide>
                {imgItem.type === "image" && <img src={imgItem.url} alt="" />}
                {imgItem.type === "video" && <img src={imgItem.url} alt="" />}
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      )}

      <div className="price-ratting-wrapper">
        <div className="ratting-wrapper">
          <span>
            <FontAwesomeIcon icon={faStar} color="#FFC107" />{" "}
            {item.ratting ? item.ratting : 0} ({item.reviews ? item.reviews : 0}
            )
          </span>
          <span>
            <FontAwesomeIcon icon={faUser} color="#000000" />{" "}
            {item.capacity ? item.capacity : 0} Person
          </span>
        </div>
        {hasSpaceRate(item.ratePerHour) ? (
          <div className="price-wrapper">{formatSpaceRate(item.ratePerHour)}</div>
        ) : (
          // Not the 25px price treatment: an unpublished rate is information,
          // not a number, and should not out-shout the space name.
          <div className="price-wrapper price-wrapper--unavailable">
            <span className="price-unavailable-label">
              {SPACE_RATE_UNAVAILABLE_LABEL}
            </span>
            <span className="price-unavailable-help">
              {SPACE_RATE_UNAVAILABLE_HELP}
            </span>
          </div>
        )}
      </div>

      <div className="space-content">
        <h3>{item.name}</h3>
        <p>
          {item.tagLine && item.tagLine}
          {/* {item.description
            ? `${String(item.description).substring(0, 50)}...`
            : ""} */}
        </p>
      </div>
    </div>
  );
};

export default SpaceGridItem;
